import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const OutputNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.OUTPUT} />;
};

export default OutputNode;
